import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  CommandColumn,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
} from "@syncfusion/ej2-react-grids";
import { useBarCodeApproveStore } from "../../../store/useBarcodeApprovetore";
import { useBarcodeStore } from "../../../store/useBarcodeMasterStore";
import { message } from "antd";

const BasicGrid = ({}) => {
  const { toggleRow, approvedRows, singleApprove } = useBarCodeApproveStore();
  const { liquidationList } = useBarcodeStore();

  const [userDetails, setUserDetails] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    if (liquidationList && liquidationList.length > 0) {
      const dataWithSerial = liquidationList.map((item, index) => ({
        ...item,
        serialNo: index + 1,

        PopulatedDate: item.PopulatedDate ? new Date(item.PopulatedDate) : null,

        ManufactureDate: item.ManufactureDate
          ? new Date(item.ManufactureDate)
          : null,

        UploadedOn: item.UploadedOn ? new Date(item.UploadedOn) : null,
      }));

      setUserDetails(dataWithSerial);
    } else {
      setUserDetails([]);
    }
  }, [liquidationList]);

  const userCommands = [
    {
      type: "Approve",
      buttonOption: {
        cssClass: "e-flat e-success",
        iconCss: "e-check e-icons", // ✔ check icon
      },
    },
  ];
  const handleCommandClick = async (args) => {
    const rowData = args.rowData;

    if (rowData.Approved !== "Pending") {
      message.error("Already Approved");
      return;
    }

    try {
      await singleApprove(rowData.Id);
    } catch (err) {
      console.error(err);
    }
  };

  let gridInstance;

  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "BrokerGrid_excelexport") {
      gridInstance.excelExport();
    }
  };

  return (
    <>
      <div
        className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
        style={{
          position: "relative",
          marginTop: "10px",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "6px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col>
            <GridComponent
              ref={(g) => (gridInstance = g)}
              id="BrokerGrid"
              dataSource={userDetails}
              allowPaging={true}
              allowSorting={true}
              allowFiltering={true}
              filterSettings={{ type: "Excel" }}
              toolbar={["ExcelExport", "Search"]}
              allowExcelExport={true}
              toolbarClick={toolbarClick}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
              gridLines="Both"
              height={"300px"}
              pageSettings={{
                pageSizes: [10, 20, 30, 40, 50, "All"],
                pageCount: 10,
              }}
              rowHeight={isMobile ? "" : 32}
              allowResizing={true}
              dataBound={() => {
                if (!isMobile && gridInstance) {
                  gridInstance.autoFitColumns();
                }
              }}
              commandClick={handleCommandClick}
              // frozenColumns={1}
              // rowDataBound={()}
              // commandClick={handleCommandClick}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="serialNo"
                  headerText="S No"
                  width="90"
                  textAlign="Center"
                  allowFiltering={false}
                />
                <ColumnDirective
                  field="Id"
                  headerText="Id"
                  width="90"
                  textAlign="Center"
                  visible={false}
                />
                <ColumnDirective
                  field="PopulatedDate"
                  headerText="Populated Date"
                  type="date"
                  format="dd/MM/yyyy"
                  width="190"
                />

                <ColumnDirective
                  field="StoreCode"
                  headerText="Store Code"
                  width="190"
                />
                <ColumnDirective
                  field="StoreName"
                  headerText="Store Name"
                  width="200"
                />
                <ColumnDirective
                  field="ItemCode"
                  headerText="Item Code"
                  width="150"
                />
                <ColumnDirective
                  field="ShortDesc"
                  headerText="Short Desc"
                  width="200"
                />

                <ColumnDirective
                  field="DivisionName"
                  headerText="Division Name"
                  width="250"
                />
                <ColumnDirective
                  field="GrnBucket"
                  headerText="GRN BUCKET"
                  width="180"
                />
                <ColumnDirective
                  field="SOH"
                  headerText="SOH"
                  width="150"
                  textAlign="Right"
                />
                <ColumnDirective
                  field="UpdatedSOH"
                  headerText="Updated SOH"
                  width="180"
                  textAlign="Right"
                />
                <ColumnDirective
                  field="Total_SOH"
                  headerText="Total SOH"
                  width="180"
                  textAlign="Right"
                />
                <ColumnDirective
                  field="ManufactureDate"
                  headerText="Manufacture Date"
                  type="date"
                  format="dd/MM/yyyy"
                  width="230"
                  textAlign="Right"
                />
                <ColumnDirective
                  field="Discount"
                  headerText="Discount"
                  width="150"
                  textAlign="Right"
                />
                <ColumnDirective
                  field="Mrp"
                  headerText="MRP"
                  width="150"
                  textAlign="Right"
                />

                <ColumnDirective
                  field="UpdatedMrp"
                  headerText="Updated MRP"
                  width="180"
                  textAlign="Right"
                />

                <ColumnDirective
                  field="UpdatedBy"
                  headerText="Updated By"
                  width="180"
                  textAlign="Right"
                />
                <ColumnDirective
                  field="UpdatedOn"
                  headerText="Updated On"
                  width="180"
                  type="date"
                  format="dd/MM/yyyy"
                />
                <ColumnDirective
                  field="Updated"
                  headerText="Updated Status"
                  width="200"
                  template={(props) => (
                    <span
                      style={{
                        fontWeight: 600,
                        color:
                          props.Updated === "Pending" ? "#f39c12" : "#28a745",
                      }}
                    >
                      {props.Updated}
                    </span>
                  )}
                />
                <ColumnDirective
                  field="Approved"
                  headerText="Approved Status"
                  width="200"
                  template={(props) => (
                    <span
                      style={{
                        fontWeight: 600,
                        color:
                          props.Approved === "Pending" ? "#f39c12" : "#28a745",
                      }}
                    >
                      {props.Approved}
                    </span>
                  )}
                />
                <ColumnDirective
                  field="checklist"
                  headerText="CheckList"
                  width="180"
                  textAlign="Center"
                  template={(props) =>
                    props.Approved === "Pending" ? (
                      <input
                        type="checkbox"
                        checked={approvedRows[props.Id] || false}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => toggleRow(props.Id, e.target.checked)}
                      />
                    ) : (
                      <span> </span>
                    )
                  }
                />

                <ColumnDirective
                  headerText="Approve"
                  width="120"
                  textAlign="Center"
                  commands={userCommands}
                  template={(props) =>
                    props.Approved === "Pending" ? (
                      <span style={{ color: "#28a745", fontWeight: 600 }}>
                        ✔
                      </span>
                    ) : null
                  }
                />
              </ColumnsDirective>

              <Inject
                services={[
                  CommandColumn,
                  Page,
                  Filter,
                  Toolbar,
                  ExcelExport,
                  Sort,
                  Group,
                  Resize,
                  Freeze,
                ]}
              />
            </GridComponent>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default BasicGrid;
